import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M14.6875 6.71875L11.4062 10L14.6875 13.3125C15.0938 13.6875 15.0938 14.3438 14.6875 14.7188C14.3125 15.125 13.6562 15.125 13.2812 14.7188L10 11.4375L6.6875 14.7188C6.3125 15.125 5.65625 15.125 5.28125 14.7188C4.875 14.3438 4.875 13.6875 5.28125 13.3125L8.5625 10L5.28125 6.71875C4.875 6.34375 4.875 5.6875 5.28125 5.3125C5.65625 4.90625 6.3125 4.90625 6.6875 5.3125L10 8.59375L13.2812 5.3125C13.6562 4.90625 14.3125 4.90625 14.6875 5.3125C15.0938 5.6875 15.0938 6.34375 14.6875 6.71875Z"
	})
});
const ForwardRef = forwardRef(SvgCloseSmall);
export default ForwardRef;
